import './sass/main.scss';
import {   
  buildAcademic,
  buildHome,
  buildStakeholders,
  buildThirdParty,
  buildTraining,
  buildWeb,
} from './imports/builders';








let dagConfigElement = null;
if(document.getElementById('dataStore')) {
  dagConfigElement = document.getElementById('dataStore');
} else if(document.getElementById('dag-config')) {
  dagConfigElement = document.getElementById('dag-config');
}
if(dagConfigElement) {
  if(process.env.ENVIRONMENT === 'development') {
    console.log('config', {
      gc: dagConfigElement.dataset.gc,
      segment: dagConfigElement.dataset.segment,
    });
  };

  switch(dagConfigElement.dataset.segment) {
    case 'home':
      if(process.env.ENVIRONMENT === 'development') console.log('building home');
      buildHome(dagConfigElement.dataset.gc);
      break;
    case 'academic':
      if(process.env.ENVIRONMENT === 'development') console.log('building academic');
      buildAcademic(dagConfigElement.dataset.segment, dagConfigElement.dataset.gc);
      break;
    case 'training':
      if(process.env.ENVIRONMENT === 'development') console.log('building training');
      buildTraining(dagConfigElement.dataset.gc);
      break;
    case '3p':
      if(process.env.ENVIRONMENT === 'development') console.log('building 3p');
      buildThirdParty();
      break;
    case 'thirdparty':
      if(process.env.ENVIRONMENT === 'development') console.log('building 3p');
      buildThirdParty();
      break;
    case 'web':
      if(process.env.ENVIRONMENT === 'development') console.log('building web');
      buildWeb(dagConfigElement.dataset.segment, dagConfigElement.dataset.gc);
      break;
    case 'stakeholders':
      if(process.env.ENVIRONMENT === 'development') console.log('building stakeholders');
      buildStakeholders();
      break;
    default:
  };
};


// Base JS
function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait = 100,
  immediate = false
) {
  let timeout: ReturnType<typeof setTimeout> | undefined;

  return function (this: unknown, ...args: Parameters<T>) {
    const context = this;
    const later = () => {
      timeout = undefined;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && timeout === undefined;
    if (timeout !== undefined) clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

const newDate = new Date();
const thisYear = newDate.getFullYear();

const newYearElement = document.querySelector('.newYear');
if (newYearElement) {
  newYearElement.innerHTML = String(thisYear);
}

/* Sticky header */
const stickyHeader = document.getElementById('ucHeader');
const sticky = stickyHeader ? stickyHeader.offsetTop + 159 : 0;

const onSticky = debounce(() => {
  if (!stickyHeader) return;

  const viewPort = window.innerWidth;

  if (window.pageYOffset >= sticky && viewPort >= 992) {
    stickyHeader.classList.add('sticky');
  } else {
    stickyHeader.classList.remove('sticky');
  }
}, 100);

window.addEventListener('scroll', onSticky, { passive: true });
window.addEventListener('resize', onSticky, { passive: true });
